import { createBrowserRouter } from "react-router-dom";
import Register from "../pages/register/register";
import Instruction from "../pages/instruction/instruction";
import Thanks from "../pages/thanks/thanks";
import Reports from "../pages/reports/reports";
import Login from "../pages/login/login";
import ProtectedRoute from "./protected-route";
import { AdminPage } from "../pages/admin/pages/admin";
import { CausalePage } from "../pages/admin/pages/causale-page";
import { Profile } from "../pages/profile/profile";
import { AdminUsersList } from "../pages/admin/pages/users/users-list";
import { AdminUsersAdd } from "../pages/admin/pages/users/users-add";
import { AdminUsersEdit } from "../pages/admin/pages/users/users-edit";
import { AdminConfigsAdd } from "../pages/admin/pages/configs/configs-add";
import { AdminConfigsEdit } from "../pages/admin/pages/configs/configs-edit";
import { AdminListConfigs } from "../pages/admin/pages/configs/configs-list";
import { ResetPwd } from "../pages/reset-pwd/reset-pwd";
import DDCurtoQuestions from "../pages/questions/dd-curto/dd-curto";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Login />,
    },
    {
        path: "/reset-pwd",
        element: <ResetPwd />,
    },
    {
        element: <ProtectedRoute allowedRoles={[]} />,
        children: [
            {
                path: "/home",
                element: <Register />,
            },
            {
                path: "/instruction",
                element: <Instruction />,
            },
            {
                path: "/questions",
                element: <DDCurtoQuestions />,
            },
            {
                path: "/thanks",
                element: <Thanks />,
            },
            {
                path: "/relatorio-pesquisa",
                element: <Reports />,
            },
            {
                path: "/admin-painel",
                element: <AdminPage />,
            },
            {
                path: "/admin-painel/add-user",
                element: <AdminUsersAdd />,
            },
            {
                path: "/admin-painel-causale",
                element: <CausalePage />,
            },
            {
                path: "/profile",
                element: <Profile />,
            },
            {
                path: "/admin-painel/users",
                element: <AdminUsersList />,
            },
            {
                path: "/admin-painel/users/add",
                element: <AdminUsersAdd />,
            },
            {
                path: "/admin-painel/users/edit/:id",
                element: <AdminUsersEdit />,
            },
            {
                path: "/admin-painel/configs/edit/:id",
                element: <AdminConfigsEdit />,
            },
            {
                path: "/admin-painel/add-configs",
                element: <AdminConfigsAdd />,
            },
            {
                path: "/admin-painel/list-configs",
                element: <AdminListConfigs />,
            }
        ]
    },
])

export default router;  